import api from '../api';
import { QuizResponse } from '../models/question';
export class QuestionService {
  public getQuiz() {
    return api.get<QuizResponse[]>('/pwa/question');
  }

  public sendQuiz(quizData: QuizResponse[], isSuspect: boolean) {
    return api.post('pwa/health', { questions: quizData, isSuspect });
  }
}

const questionService = new QuestionService();
export default questionService;
